<template>
  <baseFrame
    :infosArr='infosArr'
    :id='id'
    :idText='idText'
  >
    <div slot="content">
      <CostChangeBillTables
        :info="info"
        :financePayableCreateType="financePayableCreateType"
      ></CostChangeBillTables>
    </div>
  </baseFrame>
</template>
<script>
import CostChangeBillTables from '../../components/costChangeBillTables';
import baseFrame from '../../components/frame/BaseFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';

export default {
  name: 'costChangeBillInfo',
  components: {
    baseFrame,
    CostChangeBillTables,
  },
  data() {
    return {
      infosArr: [],
      id: '',
      idText: '成本变更单号',
      info: {},
      financePayableCreateType: 1,
    };
  },
  methods: {
    getDetails() {
      finance.getCostChangeInfo({ financeCostChangeId: `${this.$route.params.id}` }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          this.financePayableCreateType = temp.financeCostChange.financePayableCreateType;
          this.info = utils.deepClone(temp);
          this.id = this.info.financeCostChange.code;
          this.infosArr[0] = {
            name: '门店名称:',
            value: this.info.financeCostChange.storeName,
          };
          this.infosArr[1] = {
            name: '供应商名称:',
            value: this.info.financeCostChange.supplierName,
          };
          this.infosArr[2] = {
            name: '关联单号:',
            value: this.info.financeCostChange.payableCode,
          };
          this.infosArr[3] = {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(this.info.financeCostChange.createTime),
          };
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getDetails();
  },
};
</script>
<style lang="less" scoped>
  .total {
    margin-top: 12px;
    color: #1890ff;
  }
</style>
